
import React, { useState } from 'react'
import {withTranslation} from "react-i18next";

import {Box, IconButton, Paper, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyToClipboardField = withTranslation()(({t, text}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Paper sx={{my:1}}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: "row",
        justifyContent:"space-between", 
        alignItems: "flex-start",
        }}>
        <Box sx={{display: "flex", p:2}}>
            {text}
        </Box>
        <Box sx={{
              float: "right",
              display: "flex",
              alignItems: "flex-end",
          }}>
          <Tooltip title={copied ? t("copied") : t("copy-to-clipboard")}>
            <IconButton onClick={handleCopy} >
              <ContentCopyIcon sx={{height: '20px'}}/>
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Paper>
  );
})

export default CopyToClipboardField;